var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStatusView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM10 20.2024C11.5636 16.5719 15.423 14 19.9421 14C24.4612 14 28.3206 16.5719 29.8842 20.2024C28.3206 23.8329 24.4612 26.4048 19.9421 26.4048C15.423 26.4048 11.5636 23.8329 10 20.2024ZM15.423 20.2024C15.423 22.4849 17.4475 24.3374 19.9421 24.3374C22.4367 24.3374 24.4612 22.4849 24.4612 20.2024C24.4612 17.9199 22.4367 16.0675 19.9421 16.0675C17.4475 16.0675 15.423 17.9199 15.423 20.2024ZM17.2306 20.2024C17.2306 18.8296 18.4417 17.7214 19.9421 17.7214C21.4425 17.7214 22.6536 18.8296 22.6536 20.2024C22.6536 21.5752 21.4425 22.6834 19.9421 22.6834C18.4417 22.6834 17.2306 21.5752 17.2306 20.2024Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatusView);
export default __webpack_public_path__ + "static/media/icon_status-View.a27296126039dbef4e8709067095aa47.svg";
export { ForwardRef as ReactComponent };